// document.addEventListener("DOMContentLoaded", function () {
//   function handleResize() {
//     if (window.innerWidth <= 1025) {
      
//       new Swiper(".benefits-box-slider", {
//         loop: false,
//         nextButton: ".swiper-button-next",
//         prevButton: ".swiper-button-prev",
//         slidesPerView: "auto",
//         freeModeMomentum: false,
//         scrollbar: {
//           el: '.swiper-scrollbar',
//           draggable: true,
//         }
//       });
//     }
//   }

//   handleResize();
//   window.addEventListener("resize", handleResize);
// });


// document.addEventListener("DOMContentLoaded", function () {
//   function handleResize() {
//     if (window.innerWidth <= 989) {
      
//       new Swiper(".banner-logo-swiper", {
//         loop: true,
//         slidesPerView: "auto",
//         spaceBetween: 30,
//         autoplay: 
//         {
//           delay: 0,
//           disableOnInteraction: false,
//         },
//         freeMode: true,
//         speed: 5000,
//         freeModeMomentum: false
//       });
//     }
//   }

//   handleResize();
//   window.addEventListener("resize", handleResize);
// });


document.querySelectorAll('.slider-mobile-swiper2').forEach(function (element) {
  new Swiper(element, {
      // slidesPerView: "auto",
      slidesPerView: 1.25,
      spaceBetween: 15,
      loop: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
      640: {
        slidesPerView: 3,
        spaceBetween: 20
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 27
      }
    }
  });
});



document.querySelectorAll('.multicolumn-slider-row').forEach(function (element) {
    new Swiper(element, {
        // slidesPerView: "auto",
        slidesPerView: 1.25,
        spaceBetween: 15,
        loop: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
        640: {
          slidesPerView: 3,
          spaceBetween: 20
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 40
        }
      }
    });
});


const all_image_caption_inner = document.querySelectorAll('.button-link-js');
all_image_caption_inner.forEach(image_caption=>{
  if(image_caption){
   const plus_icons = image_caption.querySelector('.product-ingredient-plus-wrap');
    const ingredient_content = image_caption.querySelector('.product-ingredient-content-overlay')
    plus_icons.addEventListener('click',()=>{

      
      ingredient_content.style.cssText = "display: block; opacity: 1";
    })

    const close_button = image_caption.querySelector('.product-ingredient-close-box');
    close_button.addEventListener('click',()=>{
      ingredient_content.style.cssText = "display: none; opacity: 0";
    })
  }
});

// Tabbing js 

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.tab-target').forEach(function(tabLink) {
    tabLink.addEventListener('click', function() {
      document.querySelectorAll('.image-column-tab').forEach(function(tab) {
        tab.classList.remove('tab-active');
      });
      
      var tabId = this.getAttribute('data-id');
      document.querySelector(".image-column-tab[data-id='" + tabId + "']").classList.add('tab-active');
      
      document.querySelectorAll('.tab-target').forEach(function(tabLink) {
          tabLink.classList.remove('tab-active');
      });
      this.classList.add('tab-active');
    });
  });
});


// product Tabbing js 

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.product-tab-target').forEach(function(tabLink) {
    tabLink.addEventListener('click', function() {
      document.querySelectorAll('.product-tab-content').forEach(function(tab) {
        tab.classList.remove('tab-active');
      });
      
      var tabId = this.getAttribute('data-id');
      document.querySelector(".product-tab-content[data-id='" + tabId + "']").classList.add('tab-active');
      
      document.querySelectorAll('.product-tab-target').forEach(function(tabLink) {
          tabLink.classList.remove('tab-active');
      });
      this.classList.add('tab-active');
    });
  });


// Shop Now button scroll.
  const redirectedID = document.querySelector('#main_featured_product');
  const AllScrollingButtons = document.querySelectorAll('.scrolling_button');
  if(AllScrollingButtons.length > 0){
    AllScrollingButtons.forEach(button=>{
      if(button){
        button.addEventListener('click', ()=>{
          redirectedID.scrollIntoView({ behavior: 'smooth' });
        })
      }
    })
  }
});


/* bundle selector js */

$(document).ready(function(){
  // Nie działaj dla Black Friday widżetu (#main_featured_product)
  if ($('#main_featured_product').length) {
    // Jeśli jest Black Friday widżet, pomiń inicjalizację dla niego
    var activeBundle = $('.featured-product:not(#main_featured_product) .bundle_selector_wrapper .bundle_items.active');
    if (!activeBundle.length) {
      return; // Jeśli nie ma standardowego widżetu, wyjdź
    }
  }
  
  var active_qty = $('.featured-product:not(#main_featured_product) .bundle_selector_wrapper .bundle_items.active').attr('bundle_qty');
var html = `<input class="bundle_qty" type="hidden" name="quantity" value="${active_qty}">`;
        $('product-form.product-form input.product-variant-id').after(html);
 var otp_prices = $('.featured-product:not(#main_featured_product) .bundle_selector_wrapper .bundle_items.active').attr('otp_price');
   var comp_otp_pricee = $('.featured-product:not(#main_featured_product) .bundle_selector_wrapper .bundle_items.active').attr('comp_otp_price');
  

  // Wyklucz Black Friday sekcję z aktualizacji cen - użyj filter aby wykluczyć elementy w #main_featured_product
  $('.subscription_main .onetime-Cprice.price-item--regular').filter(function() {
    return !$(this).closest('#main_featured_product').length;
  }).text(comp_otp_pricee);
  
  $('.subscription_price.price--on-sale .subscription-price.price-item--regular').filter(function() {
    return !$(this).closest('#main_featured_product').length;
  }).text(comp_otp_pricee);
  
  $('.subscription_main .product__subs__group.one_time span.onetime-price').filter(function() {
    return !$(this).closest('#main_featured_product').length;
  }).text(otp_prices);
    
 var discount_prices = $('.featured-product:not(#main_featured_product) .bundle_selector_wrapper .bundle_items.active').attr('discount_price');
 $('.subscription_price.price--on-sale span.onetime-price').filter(function() {
    return !$(this).closest('#main_featured_product').length;
  }).text(discount_prices);
  
  
$(document).on('click', '.featured-product .bundle_selector_wrapper .bundle_items', function(e) {
  // Nie działaj dla Black Friday widżetu (#main_featured_product)
  if ($(this).closest('#main_featured_product').length) {
    return; // Pomiń jeśli kliknięto w Black Friday widżecie
  }
  
  e.preventDefault();

      $('.bundle_qty').remove();
    $('.featured-product:not(#main_featured_product) .bundle_selector_wrapper .bundle_items').removeClass('active');

    $(this).addClass('active');


    var bundleQty = $(this).attr('bundle_qty');
     var html = `<input class="bundle_qty" type="hidden" name="quantity" value="${bundleQty}">`;
        $('product-form.product-form input.product-variant-id').after(html);
    
 var otp_prices = $(this).attr('otp_price');
     var comp_otp_pricee = $(this).attr('comp_otp_price');
  
  // Wyklucz Black Friday sekcję z aktualizacji cen - użyj filter aby wykluczyć elementy w #main_featured_product
  $('.subscription_main .onetime-Cprice.price-item--regular').filter(function() {
    return !$(this).closest('#main_featured_product').length;
  }).text(comp_otp_pricee);
  
  $('.subscription_price.price--on-sale .subscription-price.price-item--regular').filter(function() {
    return !$(this).closest('#main_featured_product').length;
  }).text(comp_otp_pricee);
  
  $('.subscription_main .product__subs__group.one_time span.onetime-price').filter(function() {
    return !$(this).closest('#main_featured_product').length;
  }).text(otp_prices);
    
 var discount_prices = $(this).attr('discount_price');
 $('.subscription_price.price--on-sale span.onetime-price').filter(function() {
    return !$(this).closest('#main_featured_product').length;
  }).text(discount_prices);

  let selectedOption = $('.product__subs:not(#main_featured_product .product__subs) input[name="selling-plan-group"]:checked').data('button');
  if (selectedOption === 'subscription') {
     var susb_rpcie = $('.featured-product:not(#main_featured_product) .bundle_selector_wrapper .bundle_items.active').attr('new_dis_price_sub');
    var susb_rpcie_22 = $('.featured-product:not(#main_featured_product) .bundle_selector_wrapper .bundle_items.active').find('.serving_text').text();
       $('.featured-product:not(#main_featured_product) .pre_serving_wrapper .text.las_data').text(susb_rpcie+ ' / serving');
    $('.featured-product:not(#main_featured_product) .pre_serving_wrapper .text.ser_per').text(susb_rpcie_22);
  } else if (selectedOption === 'onetime') {
  var onetime_price = $('.featured-product:not(#main_featured_product) .bundle_selector_wrapper .bundle_items.active').attr('new_price_one');
    var susb_rpcie_32 = $('.featured-product:not(#main_featured_product) .bundle_selector_wrapper .bundle_items.active').find('.serving_text').text();
 $('.featured-product:not(#main_featured_product) .pre_serving_wrapper .text.las_data').text(onetime_price + ' / serving');
     $('.featured-product:not(#main_featured_product) .pre_serving_wrapper .text.ser_per').text(susb_rpcie_32);
  }

    
  });
});


// $(document).on('change', '#selling_plan_id_select', function () {
//   var selectedValue = $(this).val();
//   $('.product-form input#selling_plane').val(selectedValue);
// });






$('#selling_plan_id_select').on('click change', function (e) {
  e.stopPropagation();
    var selectedValue = $(this).val();
      $('input#selling_plane').val(selectedValue);
});
